<div class="flexbox">
	<img [src]="aoLostImgUrl" alt="Lost Auto Owners Logo" class="not-found-image" />
	<div>
		<h1 class="ao-orange ao-heading-100 ao-bottom-24 error-heading">Sorry, we couldn't find that page.</h1>
		<p>Do you want to try one of these instead?</p>
		<ul>
			<li><a routerLink="/track-a-claim">Track a Claim</a></li>
			<li><a href="https://www.auto-owners.com/" target="_self">Home</a></li>
		</ul>
	</div>
</div>
